module.exports = __webpack_public_path__ + "img/vertical_4_4_8011.f77e669a.png";